import {
	Loading
} from 'element-ui';

Array.prototype.insert = function(index, item) {
	this.splice(index, 0, item);
}

Array.prototype.remove = function(index) {
	this.splice(index, 1);
	return this
};

String.prototype.contains = function(val) {
	return (this.toLocaleUpperCase().indexOf(val.toLocaleUpperCase()) != -1)

};
Array.prototype.contains = function(val) {
	for (var i = 0; i < this.length; i++) {
		if (this[i] == val) {
			return true;
		}
	}
	return false;
};
Array.prototype.pushNoRepeat = function() {
	for (var i = 0; i < arguments.length; i++) {
		var ele = arguments[i];
		if (this.indexOf(ele) == -1) {
			this.push(ele);
		}
	}
};



Date.prototype.Format = function(fmt) { //author: meizz 
	var o = {
		"M+": this.getMonth() + 1, //月份 
		"d+": this.getDate(), //日 
		"h+": this.getHours(), //小时 
		"m+": this.getMinutes(), //分 
		"s+": this.getSeconds(), //秒 
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度 
		"S": this.getMilliseconds() //毫秒 
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[
			k]).substr(("" + o[k]).length)));
	return fmt;
}

String.prototype.myReplace = function(f, e) { //吧f替换成e
	var reg = new RegExp(f, "g"); //创建正则RegExp对象   
	return this.replace(reg, e);
}

Vue.directive('bgImgFixed', function(el, binding, vnode) {

	el.style.backgroundImage = `url("` + encodeURI(binding.value) + `")`
	el.style.backgroundSize = 'contain'
	el.style.backgroundRepeat = 'no-repeat'
	el.style.backgroundPositionX = 'center'
	el.style.backgroundPositionY = 'center'


})
Vue.directive('bgImgFull', function(el, binding, vnode) {

	el.style.backgroundImage = `url("` + encodeURI(binding.value) + `")`
	el.style.backgroundSize = '100% 100%'
	el.style.backgroundPosition = 'center'
})
//背景图
Vue.directive('bgImg', function(el, binding, vnode) {

	el.style.backgroundImage = `url("` + encodeURI(binding.value) + `")`
	el.style.backgroundSize = 'cover'
	el.style.backgroundPosition = 'center'
	el.style.backgroundRepeat = 'no-repeat'


})

//分变元显示
Vue.filter('fenToYuan', function(num) {
	if (num == null) {
		return ''
	}
	return Vue.prototype.math.divide(Vue.prototype.math.bignumber(num), Vue.prototype.math.bignumber(100)).toString()
})

//时间格式转换
Vue.filter('to_prety_date', function(date_time_str) {
	return Vue.prototype.utils.toPretyDate(date_time_str);
})

export default {
	install(vue) {

		Vue.prototype.utils = {};
		/////////////////////////////梁铭枫自定义方法开始///////////////////////////////////
		const eventHub = new vue()
		Vue.prototype.utils.event_hub = new vue()


		Vue.prototype.utils.openUrl = function(url) {
			window.open(url, "_blank")
		}
		//根据字符串层级取对象的值
		Vue.prototype.utils.getObjValueByLevelString = function(obj, keys) {
			
			let key_arr = keys ? keys.split('.') : [];

			function getValue(obj, key_arr) {

				if (key_arr.length == 0) {
					return obj;
				}
				obj = obj[key_arr[0]];
				key_arr.splice(0, 1);
				return getValue(obj, key_arr);
			}

			return getValue(obj, key_arr);
		}

		Vue.prototype.utils.setTimerEvent = function(event_name, page_name, obj) {
			//这个是定时器事件的样板
			// var template = [
			// {event_name:"refresh_order",page_name:"order",handled_ids:[],obj:{order_id:"1123343"},create_time:2011232123}
			// {event_name:"refresh_cart",page_name:"cart",handled_ids:["2011232123"],obj:{},create_time:2011232123}

			// ]

			//调用例子
			//this.utils.setTimerEvent("refresh_cart","order",["2011232123"],{order_id:"1123343"})



			/*不提倡传空值，收窄可能性*/
			if (event_name == null || page_name == null || obj == null) {
				return false
			}

			/*取storage*/
			var storage = window.localStorage
			/*取出事件数组*/
			var timer_events = JSON.parse(storage.getItem("timer_events"))
			//如果事件为null，则初始化
			if (timer_events == null) {
				timer_events = []
			}


			/*每一次setTimer的时候我们进行一次过滤，把太久的事件删掉，我们不在getTimmer做，因为getTimmer频率太高，没必要浪费*/
			for (var i = 0; i < timer_events.length; i++) {
				/*超过1分钟就删掉佢*/
				if ((new Date().getTime() - timer_events[i].create_time) > 60000) {
					timer_events.splice(i, 1)
					i--
				}
			}

			var event = {
				event_name: event_name,
				page_name: page_name,
				obj: obj,
				handled_ids: [],
				create_time: new Date().getTime(),
			}

			/*set回storage*/
			timer_events.push(event)
			storage.setItem("timer_events", JSON.stringify(timer_events))

			return true
		}

		Vue.prototype.utils.getTimerEvent = function(event_name, page_name, page_id) {

			//调用例子
			// var obj = this.utils.getTimerEvent("refresh_cart",this.page_name,this.page_id)
			// if (obj){
			// 	//做操作
			// }

			/*取storage*/
			var storage = window.localStorage
			/*取出事件数组*/
			var timer_events = JSON.parse(storage.getItem("timer_events"))

			/*如果为null或者没有事件，则直接返回*/
			if (timer_events == null || timer_events.length == 0) {
				return null
			}
			/*循环事件数组*/
			for (var i = 0; i < timer_events.length; i++) {
				var event = timer_events[i]
				if (event_name == event.event_name && page_name == event.page_name && page_id <= event.create_time) {

					/*还没处理过则进行处理并且set回Localstorage*/
					if (event.handled_ids.indexOf(page_id) == -1) {

						event.handled_ids.push(page_id)
						timer_events[i] = event
						storage.setItem("timer_events", JSON.stringify(timer_events))

						return event.obj;
					}

				}
			}

			/*如果上面循环都没有通过，则返回null*/
			return null
		}



		Vue.prototype.utils.getQiniuCenterXyUrl = function(name, x, y, scale, format, blur) {
			if (name == null) {
				return ""
			}
			if (x == null) {
				x = 500;
			}
			if (y == null) {
				y = 500;
			}
			if (scale == null) {
				scale = 1;
			}
			if (blur == null) {
				blur = "1x0"
			}

			x = parseInt(x)
			y = parseInt(y)



			if (["webp", "png", "jpg", "jpeg"].indexOf(name.split(".").pop()) != -1) {
				if (format == null) {
					format = "webp";
				}
			} else if (["gif"].indexOf(name.split(".").pop()) != -1) {
				format = name.split(".").pop();
			}


			if (format == "webp") {

				var userAgent = navigator.userAgent;
				var isChrome = userAgent.indexOf("Chrome") > -1;
				format = isChrome ? "webp" : "jpg"
			}

			let url = ""
			if (name.split(".").pop() == "mp4") {
				url = QINIU_BUCKET + "/" + name + "?vframe/" + "jpg" + "/offset/1/w/" + x * scale + "/h/" + y * scale;

			} else {
				url = QINIU_BUCKET + "/" + name + "?imageView2/1/w/" + x * scale + "/h/" + y * scale + "/format/" + format +
					"/blur/" + blur + "/q/75|imageslim";

			}
			return url;
		}
		Vue.prototype.utils.getQiniuWidthUrl = function(name, x, scale, format, blur) {

			if (name == null) {
				return ""
			}
			if (x == null) {
				x = 500;
			}
			if (scale == null) {
				scale = 1;
			}
			if (blur == null) {
				blur = "1x0"
			}
			x = parseInt(x)
			if (["webp", "png", "jpg", "jpeg"].indexOf(name.split(".").pop()) != -1) {
				if (format == null) {
					format = "webp";
				}
			} else if (["gif"].indexOf(name.split(".").pop()) != -1) {
				format = name.split(".").pop();
			}

			if (format == "webp") {

				var userAgent = navigator.userAgent;
				var isChrome = userAgent.indexOf("Chrome") > -1;
				format = isChrome ? "webp" : "jpg"
			}

			let url = ""
			if (name.split(".").pop() == "mp4") {
				url = QINIU_BUCKET + "/" + name + "?vframe/" + "jpg" + "/offset/1/w/" + x * scale

			} else {
				url = QINIU_BUCKET + "/" + name + "?imageMogr2/auto-orient/thumbnail/" + x * scale + "x/format/" + format +
					"/blur/" + blur + "/quality/75|imageslim";

			}

			return url;
		}
		Vue.prototype.utils.getQiniuOriginUrl = function(name, format, blur) {

			if (name == null) {
				return ""
			}
			if (blur == null) {
				blur = "1x0"
			}
			if (["webp", "png", "jpg", "jpeg"].indexOf(name.split(".").pop()) != -1) {
				if (format == null) {
					format = "webp";
				}
			} else if (["gif"].indexOf(name.split(".").pop()) != -1) {
				format = name.split(".").pop();
			}

			if (format == "webp") {

				var userAgent = navigator.userAgent;
				var isChrome = userAgent.indexOf("Chrome") > -1;
				format = isChrome ? "webp" : "jpg"
			}

			let url = ""
			if (name.split(".").pop() == "mp4") {
				url = QINIU_BUCKET + "/" + name + "?vframe/" + "jpg"

			} else {
				url = QINIU_BUCKET + "/" + name + "?imageMogr2/auto-orient/format/" + format + "/blur/" + blur +
					"/quality/75|imageslim";
			}

			return url;
		}
		Vue.prototype.utils.getQiniuVframeUrl = function(name, x, scale, format, offset) {

			if (name == null) {
				return ""
			}
			if (x == null) {
				x = 500;
			}
			if (scale == null) {
				scale = 1;
			}

			x = parseInt(x)

			if (format == "webp") {

				var userAgent = navigator.userAgent;
				var isChrome = userAgent.indexOf("Chrome") > -1;
				format = isChrome ? "webp" : "jpg"
			}

			// vframe/jpg/offset/1|imageView2/0/w/720

			let url = QINIU_BUCKET + "/" + name + "?vframe/" + "jpg" + "/offset/" + offset +
				"|imageMogr2/auto-orient/thumbnail/" + x * scale + "x/format/" + format + "/quality/75|imageslim";


			return url;
		}
		Vue.prototype.utils.getQiniuFileUrl = function(name, attname) {
			if (name == null) {
				name = "LOGO";
			}
			var url = QINIU_BUCKET + "/" + name;
			if (attname != null) {
				url += "?attname=" + attname;
			} else {
				var name_arr = name.split("^")
				if (name_arr.length == 3) {
					var name_origin = name_arr[1]
					url += "?attname=" + name_origin;

				}
			}
			return url;
		}
		Vue.prototype.utils.getSpecifyIndexFromArr = function(arr, id_key, id_value) {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i][id_key] == id_value) {
					return i;
				}
			}
			return -1;

		}
		Vue.prototype.utils.isAdminLogin = function() {
			var cookieval = $cookies.get("admin_session");
			if (cookieval == null || cookieval == 'nil') {
				return false;
			} else {
				return true;
			}

		}
		Vue.prototype.utils.isUserLogin = function() {
			var cookieval = $cookies.get("user_session");
			if (cookieval == null || cookieval == 'nil') {
				return false;
			} else {

				return true;
			}

		}
		Vue.prototype.utils.getCookie = function(name) {
			var cookieval = $cookies.get(name);
			if (cookieval == null || cookieval == 'nil') {
				return null;
			} else {
				return cookieval;
			}
		}
		Vue.prototype.utils.setCookie = function(name, value, expire, path) {
			if (path != "/") {
				console.log("cookie统一使用根路径")
			}
			path = "/"
			$cookies.set(name, value, expire, path);

			if (global.IS_HYBRID) {

				bridge.call("saveCookie", "{}", (ret) => {})
			}
		}
		Vue.prototype.utils.saveCookie = function(callback) {
			if (global.IS_HYBRID) {

				bridge.call("saveCookie", "{}", (ret) => {
					callback()
				})
			} else {
				callback()
			}


		}
		Vue.prototype.utils.deleteCookie = function(name) {
			$cookies.remove(name, "/")
			if (global.IS_HYBRID) {

				bridge.call("saveCookie", "{}", (ret) => {})
			}
		}
		Vue.prototype.utils.getUrlParam = function(name) {

			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		}
		Vue.prototype.utils.getUrlRelativePath = function(url) {
			var arrUrl = url.split("//")

			var start = arrUrl[1].indexOf("/")
			var relUrl = arrUrl[1].substring(start)

			return relUrl;
		}
		Vue.prototype.utils.getParamFromUrl = function(url, name) {
			var params = url.split('?'),
				val = '';
			if (params.length < 2) return '';
			var search = params[1].split('&');

			for (var i = 0, len = search.length; i < len; i++) {
				var ss = search[i].split('=');
				if (name === ss[0]) {
					val = ss[1];
					break;
				}
			}
			return val;
		}
		Vue.prototype.utils.checkPassword = function(password) {
			if (password == null) {
				return false;
			}
			if ((/^[A-Za-z0-9_]+$/.test(password)) && (6 <= password.length && password.length <= 20)) {
				return true;
			}
			return false;
		}

		Vue.prototype.utils.checkPhone = function(phone) {

			if (phone == null) {
				return false;
			}

			if ((/^1[3|4|5|7|8|9]\d{9}$/.test(phone))) {
				return true;
			}
			return false;
		}
		Vue.prototype.utils.formatJson = function(text_value) {
			var res = "";
			if (text_value == null) {
				return res;
			}
			for (var i = 0, j = 0, k = 0, ii, ele; i < text_value.length; i++) { //k:缩进，j:""个数
				ele = text_value.charAt(i);
				if (j % 2 == 0 && ele == "}") {
					k--;
					for (ii = 0; ii < k; ii++) ele = "    " + ele;
					ele = "\n" + ele;
				} else if (j % 2 == 0 && ele == "{") {
					ele += "\n";
					k++;
					for (ii = 0; ii < k; ii++) ele += "    ";
				} else if (j % 2 == 0 && ele == ",") {
					ele += "\n";
					for (ii = 0; ii < k; ii++) ele += "    ";
				} else if (ele == "\"") j++;
				res += ele;
			}
			console.log(res);
			return res;
		}

		Vue.prototype.utils.toPretyDate = function(date_time_str) {
			var suffix = "以前";

			var timestamp_change = new Date(date_time_str.substring(0, 19).replace(/-/g, '/')).getTime() / 1000;
			var timestamp_now = parseInt(new Date().getTime() / 1000); // 当前时间戳

			var different = timestamp_change - timestamp_now;

			if (different <= 0) {
				different = -different;
				suffix = "前";
			} else {
				suffix = "后";
			}

			// days = different / (24 * 60 * 60), take the floor value
			var dayDifferent = Math.floor(different / 86400);

			var days = parseInt(dayDifferent);
			var weeks = parseInt(Math.ceil(dayDifferent / 7));
			var months = parseInt(Math.ceil(dayDifferent / 30));
			var years = parseInt(Math.ceil(dayDifferent / 365));

			// It belongs to today
			if (dayDifferent <= 0) {
				// lower than 60 seconds
				if (different < 60) {
					return "刚刚";
				}

				// lower than 120 seconds => one minute and lower than 60 seconds
				if (different < 120) {
					return "1分钟" + suffix;
				}

				// lower than 60 minutes
				if (different < 60 * 60) {
					return Math.floor(different / 60) + "分钟" + suffix;
				}

				// lower than 60 * 2 minutes => one hour and lower than 60 minutes
				if (different < 7200) {
					return "1小时" + suffix;
				}

				// lower than one day
				if (different < 86400) {
					return Math.floor(different / 3600) + "小时" + suffix;

				}
			} else if (days < 7) {

				return days + "天" + suffix;
			} else if (weeks < 4) {

				return weeks + "周" + suffix;
			} else if (months < 12) {
				return months + "月" + suffix;
			} else {
				return years + "年" + suffix;
			}

			return date_time_str;
		}
		//计算距今多少天
		Vue.prototype.utils.getDayFromNow = function(date_time_str) {

			var timestamp_change = new Date(date_time_str.substring(0, 19).replace(/-/g, '/'));
			timestamp_change.setHours(0)
			timestamp_change.setMinutes(0)
			timestamp_change.setSeconds(0)
			timestamp_change.setMilliseconds(0)
			var timestamp_now = new Date(); // 当前时间戳
			timestamp_now.setHours(0)
			timestamp_now.setMinutes(0)
			timestamp_now.setSeconds(0)
			timestamp_now.setMilliseconds(0)

			var days = timestamp_change.getTime() - timestamp_now.getTime()
			days = (days / (1000 * 60 * 60 * 24));
			return days;

		}
		Vue.prototype.utils.getDistance = function(lat1, lng1, lat2, lng2) {

			var radLat1 = lat1 * Math.PI / 180.0;
			var radLat2 = lat2 * Math.PI / 180.0;
			var a = radLat1 - radLat2;
			var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
			var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(
				Math.sin(b / 2), 2)));
			s = s * 6378.137;
			s = Math.round(s * 10000) / 10000;
			return s
		}

		Vue.prototype.utils.successMessage = function(msg) {
			(new vue()).$message({
				message: msg,
				center: true,
				type: 'success',
			});
		}
		Vue.prototype.utils.errorMessage = function(msg) {
			(new vue()).$message({
				message: msg,
				center: true,
				type: 'error',
			});
		}
		Vue.prototype.utils.loading = function(text) {
			let loading = Loading.service({
				lock: true,
				text: text,
				background: 'rgba(0, 0, 0, 0.0)'
			});
			return loading
		}
		Vue.prototype.utils.copy = function(obj) {
			return JSON.parse(JSON.stringify(obj))
		}
		Vue.prototype.utils.deepCopy = function(obj) {
			
			 let dc = function(obj){
				 let objClone =  Array.isArray(obj) ? [] : {};
				 　　if (obj && typeof obj === 'object') {
				 　　　　for(let key in obj){
				 　　　　　　if (obj[key] && typeof obj[key] === 'object'){
				 　　　　　　　　objClone[key] = dc(obj[key]);
				 　　　　　　}else{
				 　　　　　　　　objClone[key] = obj[key]
				 　　　　　　}
				 　　　　}
				 　　}
				 　　return objClone;
			 }
			 
			 return dc(obj)
			
		}
		

		//本地化
		Vue.prototype.utils.local = function(key, string) {
			var lang = $cookies.get("lang")
			if (lang == null) {
				lang = (navigator.language || navigator.browserLanguage).toLowerCase()
			}
			console.log(lang)
			if (LOCAL_STRING[key] == null) {
				console.log('遗漏的翻译:' + string)
				return string
			}
			if (LOCAL_STRING[key][string] == null) {
				console.log('遗漏的翻译:' + string)
				return string
			}
			if (LOCAL_STRING[key][string][lang] == null || LOCAL_STRING[key][string][lang] == '') {
				console.log('遗漏的翻译:' + string)
				return string
			} else {
				return LOCAL_STRING[key][string][lang]
			}

		}




		Vue.prototype.utils.arrFillNull = function(arr, total) {

			for (var i = 0; i < total; i++) {
				if (i > arr.length - 1) {
					arr.push(null);
				}
			}
			return arr;

		}

		Vue.prototype.utils.nrToBr = function(text) {

			var replaceRegex = /(\n\r|\r\n|\r|\n)/g;

			text = text || '';

			return text.replace(replaceRegex, "<br/>");

		}




	}
};

/////////////////////////////梁铭枫自定义方法结束///////////////////////////////////
